
import React from "react";
import { ModeToggle } from "@/components/mode-toggle";
import UserMenu from "@/components/UserMenu";
import ViewModeToggle from "@/components/header/ViewModeToggle";
import { useIsMobile } from "@/hooks/use-mobile";

interface HeaderControlsProps {
  viewMode?: "grid" | "table";
  setViewMode?: (mode: "grid" | "table") => void;
  borderClass: string;
}

const HeaderControls = ({ viewMode, setViewMode, borderClass }: HeaderControlsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex items-center gap-2 md:gap-3">
      {/* View Mode Toggle */}
      {viewMode !== undefined && setViewMode !== undefined && (
        <ViewModeToggle 
          viewMode={viewMode} 
          setViewMode={setViewMode} 
          borderClass={borderClass} 
        />
      )}
      
      {/* Theme Toggle */}
      <ModeToggle />
      
      {/* User Menu */}
      <UserMenu />
    </div>
  );
};

export default HeaderControls;
